import { HttpParams } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { ApiDashboardService } from "@shared/data-access/api-dashboard.service";
import { urlErp } from "@shared/utils/general/url";
import { MODULO_APP } from "@auth/features/login/login.component";

const baseUrl = `${urlErp}/usuario`

@Injectable({ providedIn: 'root' })
export class UsuarioTabsService {
    private api = inject(ApiDashboardService)

    saveAccess(access: string) { return this.api.put(`${baseUrl}/accesos-directos`, { modulo: MODULO_APP, accesos: access }) }
    getAccess() { return this.api.get<{ message: string }>(`${baseUrl}/accesos-directos`, new HttpParams().set('modulo', MODULO_APP)) }
}
